var _style, _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _polygon, _polygon2, _polygon3, _path3, _path4, _path5, _path6, _path7, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _polygon12, _polygon13, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _polygon14, _polygon15, _path24, _path25, _path26, _g7, _g8, _path27, _path28, _path29, _path30, _path31, _path32, _polygon16, _path33, _path34, _path35, _g9, _polygon17, _polygon18, _polygon19, _path36, _path37, _path38, _path39, _path40, _polygon20, _polygon21, _g10, _path41, _path42, _g11, _path43, _g12, _path44, _path45, _g13, _g14, _path46, _path47, _g15, _g16, _g17, _path48, _path49, _path50, _path51, _g18, _g19, _path52, _path53, _path54, _path55, _path56, _g20, _g21, _path57, _path58, _path59, _g22, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _g23, _path67;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTalentSearch01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 962.7 599.2",
    style: {
      enableBackground: "new 0 0 962.7 599.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;opacity:0.1;fill:#008080;enable-background:new    ;}\n\t.st1{opacity:8.000000e-02;fill:#008080;}\n\t.st2{opacity:0.1;}\n\t.st3{fill:#190C00;fill-opacity:0;}\n\t.st4{opacity:4.166667e-02;fill:#190C00;enable-background:new    ;}\n\t.st5{opacity:8.333334e-02;fill:#190C00;enable-background:new    ;}\n\t.st6{opacity:0.125;fill:#190C00;enable-background:new    ;}\n\t.st7{opacity:0.1667;fill:#190C00;enable-background:new    ;}\n\t.st8{opacity:0.2083;fill:#190C00;enable-background:new    ;}\n\t.st9{opacity:0.25;fill:#190C00;enable-background:new    ;}\n\t.st10{opacity:0.2917;fill:#190C00;enable-background:new    ;}\n\t.st11{opacity:0.3333;fill:#190C00;enable-background:new    ;}\n\t.st12{opacity:0.375;fill:#190C00;enable-background:new    ;}\n\t.st13{opacity:0.4167;fill:#190C00;enable-background:new    ;}\n\t.st14{opacity:0.4583;fill:#190C00;enable-background:new    ;}\n\t.st15{opacity:0.5;fill:#190C00;enable-background:new    ;}\n\t.st16{opacity:0.5417;fill:#190C00;enable-background:new    ;}\n\t.st17{opacity:0.5833;fill:#190C00;enable-background:new    ;}\n\t.st18{opacity:0.625;fill:#190C00;enable-background:new    ;}\n\t.st19{opacity:0.6667;fill:#190C00;enable-background:new    ;}\n\t.st20{opacity:0.7083;fill:#190C00;enable-background:new    ;}\n\t.st21{opacity:0.75;fill:#190C00;enable-background:new    ;}\n\t.st22{opacity:0.7917;fill:#190C00;enable-background:new    ;}\n\t.st23{opacity:0.8333;fill:#190C00;enable-background:new    ;}\n\t.st24{opacity:0.875;fill:#190C00;enable-background:new    ;}\n\t.st25{opacity:0.9167;fill:#190C00;enable-background:new    ;}\n\t.st26{opacity:0.9583;fill:#190C00;enable-background:new    ;}\n\t.st27{fill:#190C00;}\n\t.st28{fill:#008080;}\n\t.st29{fill:url(#SVGID_1_);}\n\t.st30{fill:#DB7D37;}\n\t.st31{fill:url(#SVGID_2_);}\n\t.st32{fill:url(#SVGID_3_);}\n\t.st33{fill:url(#SVGID_4_);}\n\t.st34{fill:url(#SVGID_5_);}\n\t.st35{fill:url(#SVGID_6_);}\n\t.st36{fill:url(#SVGID_7_);}\n\t.st37{fill:#F99747;}\n\t.st38{fill:url(#SVGID_8_);}\n\t.st39{fill:url(#SVGID_9_);}\n\t.st40{fill:url(#SVGID_10_);}\n\t.st41{fill:url(#SVGID_11_);}\n\t.st42{fill:url(#SVGID_12_);}\n\t.st43{fill:url(#SVGID_13_);stroke:#A0A0A0;stroke-width:2;stroke-miterlimit:10;}\n\t.st44{fill:none;stroke:#A0A0A0;stroke-width:2;stroke-miterlimit:10;}\n\t.st45{fill:url(#SVGID_14_);}\n\t.st46{fill:url(#SVGID_15_);}\n\t.st47{fill:#096866;}\n\t.st48{fill:url(#SVGID_16_);}\n\t.st49{fill:url(#SVGID_17_);}\n\t.st50{fill:#525575;}\n\t.st51{fill:url(#SVGID_18_);}\n\t.st52{fill:url(#SVGID_19_);}\n\t.st53{fill:url(#SVGID_20_);}\n\t.st54{fill:url(#SVGID_21_);}\n\t.st55{fill:url(#SVGID_22_);}\n\t.st56{fill:url(#SVGID_23_);}\n\t.st57{fill:url(#SVGID_24_);}\n\t.st58{fill:url(#SVGID_25_);}\n\t.st59{fill:url(#SVGID_26_);}\n\t.st60{fill:url(#SVGID_27_);}\n\t.st61{fill:url(#SVGID_28_);}\n\t.st62{fill:url(#SVGID_29_);}\n\t.st63{fill:url(#SVGID_30_);}\n\t.st64{fill:url(#SVGID_31_);}\n\t.st65{fill:#FFFFFF;}\n\t.st66{fill:url(#SVGID_32_);}\n\t.st67{fill:url(#SVGID_33_);}\n\t.st68{fill:url(#SVGID_34_);}\n\t.st69{fill:url(#SVGID_35_);}\n\t.st70{fill:url(#SVGID_36_);}\n\t.st71{fill:url(#SVGID_37_);}\n\t.st72{fill:url(#SVGID_38_);}\n\t.st73{fill:url(#SVGID_39_);}\n\t.st74{fill:url(#SVGID_40_);}\n\t.st75{fill:url(#SVGID_41_);}\n\t.st76{fill:url(#SVGID_42_);}\n\t.st77{fill:url(#SVGID_43_);}\n\t.st78{fill:#E6E6E6;}\n\t.st79{fill:#070707;}\n\t.st80{fill:#F7BB92;}\n\t.st81{fill:#082947;}\n\t.st82{fill:url(#SVGID_44_);}\n\t.st83{fill:url(#SVGID_45_);}\n\t.st84{fill:url(#SVGID_46_);}\n\t.st85{fill:url(#SVGID_47_);}\n\t.st86{fill:url(#SVGID_48_);}\n\t.st87{fill:#0F1B29;}\n\t.st88{fill:#F2441C;}\n\t.st89{fill:url(#SVGID_49_);}\n\t.st90{fill:url(#SVGID_50_);}\n\t.st91{opacity:0.25;}\n\t.st92{fill:url(#SVGID_51_);}\n\t.st93{fill:url(#SVGID_52_);}\n\t.st94{fill:#F4AD7D;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311.7,504.2c44.8,4.6,89.9,6.4,134.1,7.1c104.3,1.8,208.8-6.7,311.5-25.4c70.6-12.8,131.7-41.8,143.9-118.7 c15.8-99.8-33-225.9-141.9-244.6c-33.7-5.8-68.7-5.5-101-16.6c-48.2-16.4-85.7-55.5-136.7-64.8c-52.1-9.4-110,1.7-151.8,36.6 c-18.4,15.3-34.1,33.3-48.8,52.1c-11.4,14.6-21.9,32.8-39.2,41c-21.2,10.1-45.9,2.1-69.2-1c-39.9-5.3-86.9,7.6-116.7,35.3 C64.7,234.3,55.4,288,59.6,328.3c5.5,52.8,31.6,102.4,76.8,131.6C187.4,492.9,252.8,498.2,311.7,504.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M871.1,210.1C871.1,405,694.9,563,477.5,563S84,405,84,210.1S310.4,29.9,527.8,29.9S871.1,15.2,871.1,210.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 790.3,
    cy: 452.2,
    rx: 65,
    ry: 36.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 790.3,
    cy: 452.2,
    rx: 63.8,
    ry: 35.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 790.3,
    cy: 452.2,
    rx: 62.5,
    ry: 35
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 790.3,
    cy: 452.2,
    rx: 61.2,
    ry: 34.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st7",
    cx: 790.3,
    cy: 452.2,
    rx: 60,
    ry: 33.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 790.3,
    cy: 452.2,
    rx: 58.7,
    ry: 32.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 790.3,
    cy: 452.2,
    rx: 57.5,
    ry: 32.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st10",
    cx: 790.3,
    cy: 452.2,
    rx: 56.2,
    ry: 31.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st11",
    cx: 790.3,
    cy: 452.2,
    rx: 55,
    ry: 30.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st12",
    cx: 790.3,
    cy: 452.2,
    rx: 53.7,
    ry: 30.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st13",
    cx: 790.3,
    cy: 452.2,
    rx: 52.5,
    ry: 29.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st14",
    cx: 790.3,
    cy: 452.2,
    rx: 51.2,
    ry: 28.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st15",
    cx: 790.3,
    cy: 452.2,
    rx: 50,
    ry: 28
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st16",
    cx: 790.3,
    cy: 452.2,
    rx: 48.7,
    ry: 27.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st17",
    cx: 790.3,
    cy: 452.2,
    rx: 47.5,
    ry: 26.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st18",
    cx: 790.3,
    cy: 452.2,
    rx: 46.2,
    ry: 25.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st19",
    cx: 790.3,
    cy: 452.2,
    rx: 45,
    ry: 25.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st20",
    cx: 790.3,
    cy: 452.2,
    rx: 43.7,
    ry: 24.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st21",
    cx: 790.3,
    cy: 452.2,
    rx: 42.5,
    ry: 23.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st22",
    cx: 790.3,
    cy: 452.2,
    rx: 41.2,
    ry: 23.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st23",
    cx: 790.3,
    cy: 452.2,
    rx: 40,
    ry: 22.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st24",
    cx: 790.3,
    cy: 452.2,
    rx: 38.7,
    ry: 21.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st25",
    cx: 790.3,
    cy: 452.2,
    rx: 37.5,
    ry: 21
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st26",
    cx: 790.3,
    cy: 452.2,
    rx: 36.2,
    ry: 20.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st27",
    cx: 790.3,
    cy: 452.2,
    rx: 35,
    ry: 19.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 656.8,
    cy: 325.1,
    rx: 65,
    ry: 36.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 656.8,
    cy: 325.1,
    rx: 63.8,
    ry: 35.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 656.8,
    cy: 325.1,
    rx: 62.5,
    ry: 35
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 656.8,
    cy: 325.1,
    rx: 61.2,
    ry: 34.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st7",
    cx: 656.8,
    cy: 325.1,
    rx: 60,
    ry: 33.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 656.8,
    cy: 325.1,
    rx: 58.7,
    ry: 32.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 656.8,
    cy: 325.1,
    rx: 57.5,
    ry: 32.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st10",
    cx: 656.8,
    cy: 325.1,
    rx: 56.2,
    ry: 31.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st11",
    cx: 656.8,
    cy: 325.1,
    rx: 55,
    ry: 30.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st12",
    cx: 656.8,
    cy: 325.1,
    rx: 53.7,
    ry: 30.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st13",
    cx: 656.8,
    cy: 325.1,
    rx: 52.5,
    ry: 29.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st14",
    cx: 656.8,
    cy: 325.1,
    rx: 51.2,
    ry: 28.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st15",
    cx: 656.8,
    cy: 325.1,
    rx: 50,
    ry: 28
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st16",
    cx: 656.8,
    cy: 325.1,
    rx: 48.7,
    ry: 27.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st17",
    cx: 656.8,
    cy: 325.1,
    rx: 47.5,
    ry: 26.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st18",
    cx: 656.8,
    cy: 325.1,
    rx: 46.2,
    ry: 25.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st19",
    cx: 656.8,
    cy: 325.1,
    rx: 45,
    ry: 25.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st20",
    cx: 656.8,
    cy: 325.1,
    rx: 43.7,
    ry: 24.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st21",
    cx: 656.8,
    cy: 325.1,
    rx: 42.5,
    ry: 23.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st22",
    cx: 656.8,
    cy: 325.1,
    rx: 41.2,
    ry: 23.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st23",
    cx: 656.8,
    cy: 325.1,
    rx: 40,
    ry: 22.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st24",
    cx: 656.8,
    cy: 325.1,
    rx: 38.7,
    ry: 21.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st25",
    cx: 656.8,
    cy: 325.1,
    rx: 37.5,
    ry: 21
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st26",
    cx: 656.8,
    cy: 325.1,
    rx: 36.2,
    ry: 20.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st27",
    cx: 656.8,
    cy: 325.1,
    rx: 35,
    ry: 19.6
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 554,
    cy: 200.5,
    rx: 65,
    ry: 36.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 554,
    cy: 200.5,
    rx: 63.8,
    ry: 35.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 554,
    cy: 200.5,
    rx: 62.5,
    ry: 35
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 554,
    cy: 200.5,
    rx: 61.2,
    ry: 34.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st7",
    cx: 554,
    cy: 200.5,
    rx: 60,
    ry: 33.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 554,
    cy: 200.5,
    rx: 58.7,
    ry: 32.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 554,
    cy: 200.5,
    rx: 57.5,
    ry: 32.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st10",
    cx: 554,
    cy: 200.5,
    rx: 56.2,
    ry: 31.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st11",
    cx: 554,
    cy: 200.5,
    rx: 55,
    ry: 30.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st12",
    cx: 554,
    cy: 200.5,
    rx: 53.7,
    ry: 30.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st13",
    cx: 554,
    cy: 200.5,
    rx: 52.5,
    ry: 29.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st14",
    cx: 554,
    cy: 200.5,
    rx: 51.2,
    ry: 28.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st15",
    cx: 554,
    cy: 200.5,
    rx: 50,
    ry: 28
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st16",
    cx: 554,
    cy: 200.5,
    rx: 48.7,
    ry: 27.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st17",
    cx: 554,
    cy: 200.5,
    rx: 47.5,
    ry: 26.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st18",
    cx: 554,
    cy: 200.5,
    rx: 46.2,
    ry: 25.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st19",
    cx: 554,
    cy: 200.5,
    rx: 45,
    ry: 25.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st20",
    cx: 554,
    cy: 200.5,
    rx: 43.7,
    ry: 24.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st21",
    cx: 554,
    cy: 200.5,
    rx: 42.5,
    ry: 23.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st22",
    cx: 554,
    cy: 200.5,
    rx: 41.2,
    ry: 23.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st23",
    cx: 554,
    cy: 200.5,
    rx: 40,
    ry: 22.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st24",
    cx: 554,
    cy: 200.5,
    rx: 38.7,
    ry: 21.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st25",
    cx: 554,
    cy: 200.5,
    rx: 37.5,
    ry: 21
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st26",
    cx: 554,
    cy: 200.5,
    rx: 36.2,
    ry: 20.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st27",
    cx: 554,
    cy: 200.5,
    rx: 35,
    ry: 19.6
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M778,231.4L679.3,174c-2.1-1.2-4.5-1.2-6.6,0s-3.3,3.3-3.3,5.7v24.8H668v-24.8c0-2.9,1.5-5.5,4-6.9 s5.5-1.4,8,0l98.7,57.4L778,231.4z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 707.2,
    y: 99.4,
    className: "st28",
    width: 1.4,
    height: 90.4
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M624.9,253.6l-64.1-35.2c-4.7-2.6-7.6-7.5-7.6-12.8v-61h1.4v61c0,4.8,2.6,9.3,6.9,11.6l64.1,35.2L624.9,253.6 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 654.3724,
    y1: 450.382,
    x2: 654.3724,
    y2: 519.9587,
    gradientTransform: "matrix(1 0 0 -1 -92.5289 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EBEBEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFEFF"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "596.5,74.3 527.1,34.5 527.1,127 596.5,166.8  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "599.9,72.8 596.5,74.3 527.1,34.5 530.4,32.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 689.0649,
    y1: 479.25,
    x2: 692.444,
    y2: 479.25,
    gradientTransform: "matrix(1 0 0 -1 -92.5289 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFAEAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ADADAD"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "596.5,166.8 599.9,165.3 599.9,72.8 596.5,74.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 646.5724,
    y1: 524.4982,
    x2: 646.5724,
    y2: 528.1407,
    gradientTransform: "matrix(1 0.5647 0 -1 -92.5289 238.8464)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B8B8B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFEFF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M569.1,88.4l-30.2-17c-1.1-0.6-2.1-2.1-2.1-3.2l0,0c0-1.1,0.9-1.5,2.1-0.9l30.2,17c1.1,0.6,2.1,2.1,2.1,3.2 l0,0C571.1,88.6,570.2,89,569.1,88.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 655.8724,
    y1: 515.9543,
    x2: 655.8724,
    y2: 519.5977,
    gradientTransform: "matrix(1 0.5647 0 -1 -92.5289 238.8464)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B8B8B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFEFF"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M587.7,107.4l-48.8-27.5c-1.1-0.6-2.1-2.1-2.1-3.2l0,0c0-1.1,0.9-1.5,2.1-0.9l48.8,27.5 c1.1,0.6,2.1,2.1,2.1,3.2l0,0C589.7,107.7,588.8,108.1,587.7,107.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 655.8724,
    y1: 507.4113,
    x2: 655.8724,
    y2: 511.0547,
    gradientTransform: "matrix(1 0.5647 0 -1 -92.5289 238.8464)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B8B8B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFEFF"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M587.7,116l-48.8-27.5c-1.1-0.6-2.1-2.1-2.1-3.2l0,0c0-1.1,0.9-1.5,2.1-0.9l48.8,27.5 c1.1,0.6,2.1,2.1,2.1,3.2l0,0C589.7,116.2,588.8,116.6,587.7,116z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 655.8724,
    y1: 498.8683,
    x2: 655.8724,
    y2: 502.5117,
    gradientTransform: "matrix(1 0.5647 0 -1 -92.5289 238.8464)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B8B8B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFEFF"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M587.7,124.5L538.9,97c-1.1-0.6-2.1-2.1-2.1-3.2l0,0c0-1.1,0.9-1.5,2.1-0.9l48.8,27.5 c1.1,0.6,2.1,2.1,2.1,3.2l0,0C589.7,124.7,588.8,125.1,587.7,124.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 652.5724,
    y1: 490.3257,
    x2: 652.5724,
    y2: 493.9687,
    gradientTransform: "matrix(1 0.5647 0 -1 -92.5289 238.8464)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B8B8B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFEFF"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M581.1,129.3l-42.2-23.8c-1.1-0.6-2.1-2.1-2.1-3.2l0,0c0-1.1,0.9-1.5,2.1-0.9l42.2,23.8 c1.1,0.6,2.1,2.1,2.1,3.2l0,0C583.2,129.6,582.2,130,581.1,129.3z"
  })))), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "527.1,44.2 596.5,84 596.5,74.3 527.1,34.5  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "596.5,74.3 599.9,72.8 599.9,82.4 596.5,84  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 794.4081,
    y1: 260.6565,
    x2: 774.018,
    y2: 150.7766,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EBEBEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFEFF"
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "833.6,383.2 731.3,324.5 731.3,422 833.6,480.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 739.1721,
    y1: 289.9406,
    x2: 858.0421,
    y2: 189.0636,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFAC06"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF460E"
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "845.8,377.6 833.6,383.2 731.3,324.5 743.5,318.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 839.7435,
    y1: 208.4818,
    x2: 839.7435,
    y2: 125.4357,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EBEBEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1D0CF"
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "833.6,480.7 845.8,475.1 845.8,377.6 833.6,383.2  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 782.4935,
    y1: 207.8518,
    x2: 782.4935,
    y2: 272.2573,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFAC06"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5703,
    style: {
      stopColor: "#FF720B"
    }
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "731.3,338.7 833.6,397.4 833.6,383.2 731.3,324.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 853.3682,
    y1: 201.5107,
    x2: 823.9299,
    y2: 223.2021,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFAC06"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF460E"
    }
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "833.6,383.2 845.8,377.6 845.8,391.8 833.6,397.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 782.4935,
    y1: 153.1054,
    x2: 782.4935,
    y2: 204.9087,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EBEBEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFEFF"
    }
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "821.6,405.9 743.3,361 743.3,414.6 821.6,459.5  "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st44",
    x1: 743.3,
    y1: 361,
    x2: 821.6,
    y2: 405.9
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st44",
    x1: 743.3,
    y1: 367.8,
    x2: 821.6,
    y2: 412.7
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st44",
    x1: 743.3,
    y1: 374.6,
    x2: 821.6,
    y2: 419.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st44",
    x1: 743.3,
    y1: 381.4,
    x2: 821.6,
    y2: 426.2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st44",
    x1: 743.3,
    y1: 388.1,
    x2: 821.6,
    y2: 433.1
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st44",
    x1: 743.3,
    y1: 394.9,
    x2: 821.6,
    y2: 439.8
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st44",
    x1: 743.3,
    y1: 401.7,
    x2: 821.6,
    y2: 446.6
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st44",
    x1: 743.3,
    y1: 408.5,
    x2: 821.6,
    y2: 453.4
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st44",
    x1: 753.2,
    y1: 366.5,
    x2: 753.2,
    y2: 420.1
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st44",
    x1: 776.3,
    y1: 379.7,
    x2: 776.3,
    y2: 433.2
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st44",
    x1: 799.3,
    y1: 393.4,
    x2: 799.3,
    y2: 447
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 630.0467,
    y1: 343.05,
    x2: 713.0464,
    y2: 343.05,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EBEBEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1D0CF"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M713.1,276.4c0-0.7-0.1-1.4-0.1-2c0-0.3,0-0.6-0.1-0.9c0-0.1,0-0.3,0-0.4c0-0.2,0-0.5-0.1-0.7 c-0.1-0.7-0.1-1.4-0.2-2.1c-0.1-0.7-0.2-1.4-0.3-2.1c0,0,0,0,0-0.1v-0.1c-0.1-0.7-0.2-1.3-0.3-2s-0.3-1.5-0.4-2.2 c-0.1-0.3-0.1-0.5-0.2-0.8c0-0.2-0.1-0.3-0.1-0.5c-0.1-0.3-0.1-0.6-0.2-1c-0.2-0.7-0.4-1.5-0.6-2.2c-0.1-0.5-0.3-1.1-0.5-1.6 c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.2-0.1-0.3c-0.2-0.7-0.5-1.4-0.7-2.2c-0.2-0.7-0.5-1.4-0.7-2.1c0-0.1-0.1-0.3-0.1-0.4 c0-0.1-0.1-0.2-0.1-0.3c-0.2-0.5-0.3-0.9-0.5-1.3c-0.3-0.7-0.5-1.4-0.8-2c-0.2-0.5-0.4-1-0.6-1.4c0-0.1-0.1-0.2-0.1-0.3 s-0.1-0.2-0.1-0.3c-0.3-0.7-0.6-1.4-0.9-2c-0.3-0.7-0.7-1.5-1.1-2.2c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.1-0.3-0.2-0.4 c-0.3-0.6-0.6-1.2-0.9-1.8c-0.4-0.7-0.8-1.4-1.2-2.1c-0.2-0.4-0.4-0.7-0.6-1.1c-0.1-0.1-0.2-0.3-0.2-0.4c-0.4-0.6-0.8-1.2-1.2-1.9 c-0.6-0.9-1.1-1.8-1.7-2.7c-0.1-0.1-0.2-0.3-0.3-0.4c-0.8-1.3-1.7-2.5-2.6-3.7c0,0,0-0.1-0.1-0.1l0,0c-0.6-0.8-1.2-1.6-1.9-2.5 c-0.5-0.6-1-1.3-1.5-1.9c0,0,0,0,0-0.1l0,0c-0.5-0.6-1.1-1.3-1.6-1.9c-0.5-0.6-1.1-1.2-1.6-1.8c-0.1-0.1-0.2-0.2-0.3-0.3 s-0.2-0.2-0.3-0.3c-0.4-0.4-0.8-0.8-1.2-1.2c-0.6-0.6-1.2-1.2-1.8-1.7c-0.2-0.2-0.4-0.3-0.5-0.5c-0.1-0.1-0.3-0.3-0.4-0.4 c-0.3-0.3-0.6-0.5-0.9-0.8c-0.6-0.6-1.2-1.1-1.9-1.6c-0.3-0.2-0.6-0.5-0.8-0.7c-0.1-0.1-0.3-0.2-0.4-0.3c-0.2-0.2-0.4-0.3-0.6-0.5 c-0.6-0.5-1.2-0.9-1.8-1.4c-0.4-0.3-0.9-0.6-1.3-1c-0.1-0.1-0.2-0.1-0.2-0.2c-0.1-0.1-0.2-0.1-0.2-0.2c-0.6-0.4-1.2-0.8-1.8-1.2 s-1.2-0.7-1.8-1.1c-0.1-0.1-0.3-0.2-0.4-0.2c-0.4-0.3-0.9-0.5-1.3-0.7c-0.2-0.1-0.3-0.2-0.5-0.3s-0.5-0.2-0.7-0.4 c-0.2-0.1-0.4-0.2-0.5-0.3c-0.3-0.1-0.6-0.3-0.8-0.4c-0.2-0.1-0.4-0.2-0.6-0.3c-0.1,0-0.2-0.1-0.2-0.1c-0.6-0.3-1.1-0.5-1.7-0.7 c-0.6-0.2-1.1-0.4-1.7-0.6c-0.1,0-0.1,0-0.2-0.1c-0.2-0.1-0.4-0.1-0.6-0.2c-0.3-0.1-0.6-0.2-0.9-0.3c-0.1,0-0.3-0.1-0.4-0.1 c-0.2-0.1-0.5-0.1-0.7-0.2c-0.2-0.1-0.4-0.1-0.6-0.2c-0.2,0-0.4-0.1-0.6-0.1c-0.2-0.1-0.5-0.1-0.7-0.2c-0.1,0-0.3-0.1-0.4-0.1 c-0.2,0-0.5-0.1-0.7-0.1c-0.3,0-0.6-0.1-0.9-0.1c-0.1,0-0.2,0-0.3,0c-0.2,0-0.5,0-0.7-0.1c-0.3,0-0.6-0.1-0.9-0.1 c-0.1,0-0.2,0-0.3,0c-0.2,0-0.4,0-0.6,0c-0.4,0-0.7,0-1.1,0c-0.1,0-0.2,0-0.3,0c-0.2,0-0.3,0-0.5,0c-0.4,0-0.9,0-1.3,0.1 c-0.1,0-0.3,0-0.4,0c-0.1,0-0.2,0-0.3,0c-0.7,0.1-1.3,0.2-2,0.3c-0.1,0-0.1,0-0.2,0l0,0c-0.9,0.2-1.8,0.4-2.7,0.7 c-0.1,0-0.2,0-0.2,0.1c-0.1,0-0.1,0.1-0.2,0.1c-0.4,0.1-0.7,0.3-1.1,0.5c-0.2,0.1-0.4,0.1-0.5,0.2c-0.5,0.3-1.1,0.5-1.6,0.8 l-11.4,6.6c0.5-0.3,1-0.6,1.6-0.8c0.2-0.1,0.4-0.2,0.5-0.2c0.4-0.2,0.7-0.3,1.1-0.5c0.1-0.1,0.3-0.1,0.4-0.1 c0.9-0.3,1.7-0.5,2.7-0.7c0.1,0,0.1,0,0.2,0c0.6-0.1,1.3-0.2,2-0.3c0.2,0,0.5,0,0.7-0.1c0.4,0,0.9-0.1,1.3-0.1c0.3,0,0.5,0,0.8,0 s0.7,0,1.1,0c0.3,0,0.6,0,0.9,0c0.3,0,0.6,0.1,0.9,0.1c0.3,0,0.7,0.1,1,0.1s0.6,0.1,0.9,0.1c0.4,0.1,0.7,0.1,1.1,0.2 c0.2,0.1,0.5,0.1,0.7,0.2c0.4,0.1,0.8,0.2,1.2,0.3c0.2,0.1,0.5,0.1,0.7,0.2c0.4,0.1,0.9,0.3,1.3,0.4c0.2,0.1,0.4,0.1,0.6,0.2 c1.3,0.4,2.5,0.9,3.8,1.5c0.2,0.1,0.4,0.2,0.6,0.3c0.5,0.2,0.9,0.4,1.4,0.7c0.2,0.1,0.5,0.2,0.7,0.4c0.6,0.3,1.2,0.7,1.8,1 c1.4,0.8,2.8,1.7,4.2,2.7c0.1,0.1,0.2,0.1,0.2,0.2c1.3,0.9,2.6,1.9,3.8,2.9c0.1,0.1,0.3,0.2,0.4,0.3c1.2,1,2.4,2,3.6,3.1 c0.1,0.1,0.3,0.3,0.4,0.4c1.2,1.1,2.3,2.3,3.5,3.5c0.1,0.1,0.2,0.2,0.3,0.3c1.2,1.3,2.4,2.6,3.5,4c0,0,0,0,0,0.1 c1.2,1.4,2.3,2.9,3.4,4.4c0,0,0,0.1,0.1,0.1c1,1.3,1.9,2.7,2.9,4.1c0.6,0.9,1.1,1.8,1.7,2.7c0.5,0.8,1,1.5,1.4,2.3 c0.2,0.4,0.4,0.7,0.6,1.1c0.7,1.3,1.4,2.6,2.1,3.9c0.1,0.1,0.1,0.3,0.2,0.4c0.8,1.6,1.6,3.2,2.3,4.9c0,0.1,0.1,0.2,0.1,0.3 c0.7,1.6,1.3,3.2,1.9,4.8c0,0.1,0.1,0.2,0.1,0.3c0.6,1.7,1.2,3.3,1.7,5c0,0.1,0.1,0.2,0.1,0.3c0.5,1.6,0.9,3.2,1.3,4.8 c0,0.2,0.1,0.3,0.1,0.5c0.4,1.7,0.7,3.3,1,4.9v0.1c0.3,1.7,0.5,3.3,0.6,4.9c0,0.1,0,0.3,0,0.4c0.1,1.6,0.2,3.3,0.2,4.8 c0,0.8,0,1.5-0.1,2.3c0,0.2,0,0.4,0,0.6c0,0.5-0.1,1-0.1,1.5c0,0.3-0.1,0.6-0.1,0.9c0,0.4-0.1,0.8-0.2,1.3c0,0.3-0.1,0.6-0.1,0.9 c-0.1,0.4-0.1,0.8-0.2,1.1c-0.1,0.3-0.1,0.7-0.2,1c-0.1,0.3-0.1,0.7-0.2,1c-0.1,0.4-0.2,0.8-0.3,1.2c-0.1,0.3-0.2,0.6-0.3,0.9 c-0.1,0.5-0.3,0.9-0.4,1.3c-0.1,0.2-0.2,0.5-0.2,0.7c-0.3,0.7-0.6,1.4-0.9,2.1c0,0.1-0.1,0.1-0.1,0.2c-0.4,0.9-0.9,1.8-1.4,2.6 c0,0.1-0.1,0.1-0.1,0.2c-0.4,0.7-0.9,1.3-1.4,1.9c-0.1,0.1-0.2,0.3-0.3,0.4c-0.5,0.6-0.9,1.1-1.4,1.6l-0.1,0.1 c-0.5,0.5-1.1,1-1.7,1.5c-0.1,0.1-0.3,0.2-0.4,0.3c-0.6,0.4-1.2,0.9-1.8,1.2l0,0l0,0l11.4-6.6c0.6-0.4,1.2-0.8,1.8-1.2 c0.1-0.1,0.3-0.2,0.4-0.3c0.6-0.5,1.1-0.9,1.7-1.5l0.1-0.1c0.5-0.5,1-1,1.4-1.6c0.1-0.1,0.2-0.3,0.3-0.4c0.5-0.6,0.9-1.2,1.4-1.9 c0,0,0,0,0-0.1c0,0,0-0.1,0.1-0.1c0.5-0.8,1-1.7,1.4-2.6c0-0.1,0.1-0.1,0.1-0.1s0,0,0-0.1c0.3-0.7,0.6-1.4,0.9-2.1 c0-0.1,0.1-0.1,0.1-0.2c0.1-0.2,0.1-0.3,0.2-0.5c0.2-0.4,0.3-0.9,0.4-1.3c0-0.1,0.1-0.2,0.1-0.4c0-0.2,0.1-0.4,0.1-0.5 c0.1-0.4,0.2-0.8,0.3-1.2c0-0.2,0.1-0.3,0.1-0.5s0.1-0.4,0.1-0.5c0.1-0.3,0.1-0.7,0.2-1c0-0.2,0.1-0.3,0.1-0.5s0.1-0.4,0.1-0.6 c0-0.3,0.1-0.6,0.1-0.9c0-0.2,0-0.3,0.1-0.5c0-0.3,0.1-0.5,0.1-0.8s0.1-0.6,0.1-0.9c0-0.1,0-0.2,0-0.3c0-0.4,0.1-0.8,0.1-1.2 c0-0.2,0-0.4,0-0.6c0-0.1,0-0.1,0-0.2c0-0.7,0-1.3,0-2v-0.1C713.1,277.6,713.1,277,713.1,276.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 617.8431,
    y1: 338.3987,
    x2: 701.7438,
    y2: 338.3987,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EBEBEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFEFF"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M659.9,212.4c23.2,13.4,41.9,45.8,41.8,72.5c-0.1,26.6-18.9,37.4-42.1,24c-23.2-13.4-41.9-45.8-41.8-72.4 C617.8,209.8,636.7,199,659.9,212.4z"
  })))), /*#__PURE__*/React.createElement("g", null, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M647.7,261.6c0,0-7.6-2.9-14.1-2.1c-6.4,0.8-7.8,7.1-7.8,7.1s3.9,18.5,24.6,35.8 c17.3,14.4,32.1,11.9,32.1,11.9s0.7-30.5-1.2-33.2s-19.1-16.8-19.1-16.8L647.7,261.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 650.6364,
    y1: 339.6328,
    x2: 662.9718,
    y2: 339.491,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC5C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DE8B8B"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M647.8,259.6l-0.3,4.8c0,0,0.6,4,6.1,4.3s9.7-2.3,9.7-2.3v-16.1L647.8,259.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 641.9906,
    y1: 353.7,
    x2: 666.5558,
    y2: 353.7,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC5C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DE8B8B"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M643.5,232.5c0,0-0.6,5.4,0,7.5s0.6,2.1,0.6,2.1s-2.2,1-2.2,3.2s0.5,9.9,1.1,11.3s5.4,3.3,5.4,3.3 s10.3-1.8,11.8-2.6c1.5-0.7,7.6-5.8,6-13.4c-1.6-7.6-10.2-13.1-10.2-13.1L643.5,232.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M641.9,231.7c0,0,0.1,7.2,9.1,7.4c9,0.1,9,0.1,9,0.1s-1.1,5.4,0,7s0.9,4.7,1.6,5.2c0.7,0.5,0.2-6.6,2.1-6 c1.8,0.7-0.5,7.8,0.8,7.7s5.3-3.6,6.7-9.9s-1-10.7-1-10.7s1.9-6.9-5.7-8.5S644.8,228.5,641.9,231.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 655.5881,
    y1: 328.8552,
    x2: 667.2626,
    y2: 328.721,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EBEBEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1D0CF"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M652.7,268.7c0.3-0.1,3.4,8.2,3.4,8.2l11.7-8.2l-3.2-5.1L652.7,268.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 645.1144,
    y1: 332.9061,
    x2: 650.2542,
    y2: 332.847,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EBEBEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1D0CF"
    }
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st52",
    points: "647.5,259.9 650.4,268 643.7,272.4 644.2,260.5  "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "650.4,268 652.7,268.7 654.2,272.4 652.7,272.4 648.2,300.5 641.3,293.6 648.6,271.4 647.5,269.9  "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M681.2,281.1c0,0-8,5.9-9.1,17.1s-0.6,15.6-0.6,15.6s8.2,1.2,11.5,0.8c3.3-0.4,5.3-2.3,5.3-2.3 S686.7,282.4,681.2,281.1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M634.9,259.5c0,0-2.9,4.5-4.1,9.2s-1.1,8.2-1.1,8.2l-4.3-10.8C625.3,266.2,628.6,258.2,634.9,259.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 683.7585,
    y1: 525.75,
    x2: 766.7582,
    y2: 525.75,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EBEBEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1D0CF"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M766.8,93.7c0-0.7-0.1-1.4-0.1-2c0-0.3,0-0.6-0.1-0.9c0-0.1,0-0.3,0-0.4c0-0.2,0-0.5-0.1-0.7 c-0.1-0.7-0.1-1.4-0.2-2.1c-0.1-0.7-0.2-1.4-0.3-2.1c0,0,0,0,0-0.1v-0.1c-0.1-0.7-0.2-1.3-0.3-2s-0.3-1.5-0.4-2.2 c-0.1-0.3-0.1-0.5-0.2-0.8c0-0.2-0.1-0.3-0.1-0.5c-0.1-0.3-0.1-0.6-0.2-1c-0.2-0.7-0.4-1.5-0.6-2.2c-0.1-0.5-0.3-1.1-0.5-1.6 c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.2-0.1-0.3c-0.2-0.7-0.5-1.4-0.7-2.2c-0.2-0.7-0.5-1.4-0.7-2.1c0-0.1-0.1-0.3-0.1-0.4 s-0.1-0.2-0.1-0.3c-0.2-0.5-0.3-0.9-0.5-1.3c-0.3-0.7-0.5-1.4-0.8-2c-0.2-0.5-0.4-1-0.6-1.4c0-0.1-0.1-0.2-0.1-0.3 c0-0.1-0.1-0.2-0.1-0.3c-0.3-0.7-0.6-1.4-0.9-2c-0.3-0.7-0.7-1.5-1.1-2.2c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.1-0.3-0.2-0.4 c-0.3-0.6-0.6-1.2-0.9-1.8c-0.4-0.7-0.8-1.4-1.2-2.1c-0.2-0.4-0.4-0.7-0.6-1.1c-0.1-0.1-0.2-0.3-0.2-0.4c-0.4-0.6-0.8-1.2-1.2-1.9 c-0.6-0.9-1.1-1.8-1.7-2.7c-0.1-0.1-0.2-0.3-0.3-0.4c-0.8-1.3-1.7-2.5-2.6-3.7c0,0,0-0.1-0.1-0.1l0,0c-0.6-0.8-1.2-1.6-1.9-2.5 c-0.5-0.6-1-1.3-1.5-1.9c0,0,0,0,0-0.1l0,0c-0.5-0.6-1.1-1.3-1.6-1.9c-0.5-0.6-1.1-1.2-1.6-1.8c-0.1-0.1-0.2-0.2-0.3-0.3 s-0.2-0.2-0.3-0.3c-0.4-0.4-0.8-0.8-1.2-1.2c-0.6-0.6-1.2-1.2-1.8-1.7c-0.2-0.2-0.4-0.3-0.5-0.5c-0.1-0.1-0.3-0.3-0.4-0.4 c-0.3-0.3-0.6-0.5-0.9-0.8c-0.6-0.6-1.2-1.1-1.9-1.6c-0.3-0.2-0.6-0.5-0.8-0.7c-0.1-0.1-0.3-0.2-0.4-0.3c-0.2-0.2-0.4-0.3-0.6-0.5 c-0.6-0.5-1.2-0.9-1.8-1.4c-0.4-0.3-0.9-0.6-1.3-1c-0.1-0.1-0.2-0.1-0.2-0.2c-0.1-0.1-0.2-0.1-0.2-0.2c-0.6-0.4-1.2-0.8-1.8-1.2 s-1.2-0.7-1.8-1.1c-0.1-0.1-0.3-0.2-0.4-0.2c-0.4-0.3-0.9-0.5-1.3-0.7c-0.2-0.1-0.3-0.2-0.5-0.3s-0.5-0.2-0.7-0.4 c-0.2-0.1-0.4-0.2-0.5-0.3c-0.3-0.1-0.6-0.3-0.8-0.4c-0.2-0.1-0.4-0.2-0.6-0.3c-0.1,0-0.2-0.1-0.2-0.1c-0.6-0.3-1.1-0.5-1.7-0.7 c-0.6-0.2-1.1-0.4-1.7-0.6c-0.1,0-0.1,0-0.2-0.1c-0.2-0.1-0.4-0.1-0.6-0.2c-0.3-0.1-0.6-0.2-0.9-0.3c-0.1,0-0.3-0.1-0.4-0.1 c-0.2-0.1-0.5-0.1-0.7-0.2c-0.2-0.1-0.4-0.1-0.6-0.2c-0.2,0-0.4-0.1-0.6-0.1c-0.2-0.1-0.5-0.1-0.7-0.2c-0.1,0-0.3-0.1-0.4-0.1 c-0.2,0-0.5-0.1-0.7-0.1c-0.3,0-0.6-0.1-0.9-0.1c-0.1,0-0.2,0-0.3,0c-0.2,0-0.5,0-0.7-0.1c-0.3,0-0.6-0.1-0.9-0.1 c-0.1,0-0.2,0-0.3,0c-0.2,0-0.4,0-0.6,0c-0.4,0-0.7,0-1.1,0c-0.1,0-0.2,0-0.3,0c-0.2,0-0.3,0-0.5,0c-0.4,0-0.9,0-1.3,0.1 c-0.1,0-0.3,0-0.4,0c-0.1,0-0.2,0-0.3,0c-0.7,0.1-1.3,0.2-2,0.3c-0.1,0-0.1,0-0.2,0l0,0c-0.9,0.2-1.8,0.4-2.7,0.7 c-0.1,0-0.2,0-0.2,0.1c-0.1,0-0.1,0.1-0.2,0.1c-0.4,0.1-0.7,0.3-1.1,0.5c-0.2,0.1-0.4,0.1-0.5,0.2c-0.5,0.3-1.1,0.5-1.6,0.8 l-11.4,6.6c0.5-0.3,1-0.6,1.6-0.8c0.2-0.1,0.4-0.2,0.5-0.2c0.4-0.2,0.7-0.3,1.1-0.5c0.1-0.1,0.3-0.1,0.4-0.1 c0.9-0.3,1.7-0.5,2.7-0.7c0.1,0,0.1,0,0.2,0c0.6-0.1,1.3-0.2,2-0.3c0.2,0,0.5,0,0.7-0.1c0.4,0,0.9-0.1,1.3-0.1c0.3,0,0.5,0,0.8,0 s0.7,0,1.1,0c0.3,0,0.6,0,0.9,0c0.3,0,0.6,0.1,0.9,0.1c0.3,0,0.7,0.1,1,0.1s0.6,0.1,0.9,0.1c0.4,0.1,0.7,0.1,1.1,0.2 c0.2,0.1,0.5,0.1,0.7,0.2c0.4,0.1,0.8,0.2,1.2,0.3c0.2,0.1,0.5,0.1,0.7,0.2c0.4,0.1,0.9,0.3,1.3,0.4c0.2,0.1,0.4,0.1,0.6,0.2 c1.3,0.4,2.5,0.9,3.8,1.5c0.2,0.1,0.4,0.2,0.6,0.3c0.5,0.2,0.9,0.4,1.4,0.7c0.2,0.1,0.5,0.2,0.7,0.4c0.6,0.3,1.2,0.7,1.8,1 c1.4,0.8,2.8,1.7,4.2,2.7c0.1,0.1,0.2,0.1,0.2,0.2c1.3,0.9,2.6,1.9,3.8,2.9c0.1,0.1,0.3,0.2,0.4,0.3c1.2,1,2.4,2,3.6,3.1 c0.1,0.1,0.3,0.3,0.4,0.4c1.2,1.1,2.3,2.3,3.5,3.5c0.1,0.1,0.2,0.2,0.3,0.3c1.2,1.3,2.4,2.6,3.5,4c0,0,0,0,0,0.1 c1.2,1.4,2.3,2.9,3.4,4.4c0,0,0,0.1,0.1,0.1c1,1.3,1.9,2.7,2.9,4.1c0.6,0.9,1.1,1.8,1.7,2.7c0.5,0.8,1,1.5,1.4,2.3 c0.2,0.4,0.4,0.7,0.6,1.1c0.7,1.3,1.4,2.6,2.1,3.9c0.1,0.1,0.1,0.3,0.2,0.4c0.8,1.6,1.6,3.2,2.3,4.9c0,0.1,0.1,0.2,0.1,0.3 c0.7,1.6,1.3,3.2,1.9,4.8c0,0.1,0.1,0.2,0.1,0.3c0.6,1.7,1.2,3.3,1.7,5c0,0.1,0.1,0.2,0.1,0.3c0.5,1.6,0.9,3.2,1.3,4.8 c0,0.2,0.1,0.3,0.1,0.5c0.4,1.7,0.7,3.3,1,4.9v0.1c0.3,1.7,0.5,3.3,0.6,4.9c0,0.1,0,0.3,0,0.4c0.1,1.6,0.2,3.3,0.2,4.8 c0,0.8,0,1.5-0.1,2.3c0,0.2,0,0.4,0,0.6c0,0.5-0.1,1-0.1,1.5c0,0.3-0.1,0.6-0.1,0.9c0,0.4-0.1,0.8-0.2,1.3c0,0.3-0.1,0.6-0.1,0.9 c-0.1,0.4-0.1,0.8-0.2,1.1c-0.1,0.3-0.1,0.7-0.2,1c-0.1,0.3-0.1,0.7-0.2,1c-0.1,0.4-0.2,0.8-0.3,1.2c-0.1,0.3-0.2,0.6-0.3,0.9 c-0.1,0.5-0.3,0.9-0.4,1.3c-0.1,0.2-0.2,0.5-0.2,0.7c-0.3,0.7-0.6,1.4-0.9,2.1c0,0.1-0.1,0.1-0.1,0.2c-0.4,0.9-0.9,1.8-1.4,2.6 c0,0.1-0.1,0.1-0.1,0.2c-0.4,0.7-0.9,1.3-1.4,1.9c-0.1,0.1-0.2,0.3-0.3,0.4c-0.5,0.6-0.9,1.1-1.4,1.6l-0.1,0.1 c-0.5,0.5-1.1,1-1.7,1.5c-0.1,0.1-0.3,0.2-0.4,0.3c-0.6,0.4-1.2,0.9-1.8,1.2l0,0l0,0l11.4-6.6c0.6-0.4,1.2-0.8,1.8-1.2 c0.1-0.1,0.3-0.2,0.4-0.3c0.6-0.5,1.1-0.9,1.7-1.5l0.1-0.1c0.5-0.5,1-1,1.4-1.6c0.1-0.1,0.2-0.3,0.3-0.4c0.5-0.6,0.9-1.2,1.4-1.9 c0,0,0,0,0-0.1c0,0,0-0.1,0.1-0.1c0.5-0.8,1-1.7,1.4-2.6c0-0.1,0.1-0.1,0.1-0.1s0,0,0-0.1c0.3-0.7,0.6-1.4,0.9-2.1 c0-0.1,0.1-0.1,0.1-0.2c0.1-0.2,0.1-0.3,0.2-0.5c0.2-0.4,0.3-0.9,0.4-1.3c0-0.1,0.1-0.2,0.1-0.4c0-0.2,0.1-0.4,0.1-0.5 c0.1-0.4,0.2-0.8,0.3-1.2c0-0.2,0.1-0.3,0.1-0.5s0.1-0.4,0.1-0.5c0.1-0.3,0.1-0.7,0.2-1c0-0.2,0.1-0.3,0.1-0.5s0.1-0.4,0.1-0.6 c0-0.3,0.1-0.6,0.1-0.9c0-0.2,0-0.3,0.1-0.5c0-0.3,0.1-0.5,0.1-0.8s0.1-0.6,0.1-0.9c0-0.1,0-0.2,0-0.3c0-0.4,0.1-0.8,0.1-1.2 c0-0.2,0-0.4,0-0.6c0-0.1,0-0.1,0-0.2c0-0.7,0-1.3,0-2v-0.1C766.8,94.9,766.8,94.3,766.8,93.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 671.5431,
    y1: 521.0988,
    x2: 755.4438,
    y2: 521.0988,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EBEBEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFEFF"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M713.6,29.7c23.2,13.4,41.9,45.8,41.8,72.5c-0.1,26.6-18.9,37.4-42.1,24s-41.9-45.8-41.8-72.4 C671.5,27.1,690.4,16.3,713.6,29.7z"
  })))), /*#__PURE__*/React.createElement("g", null, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M696.2,51.7c0,0-4.5,7.3-2.2,13.3c2.2,6,6.8,6.5,6.8,6.5l1.8-13.8L696.2,51.7z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M701.4,78.9c0,0-7.6-2.9-14.1-2.1c-6.4,0.8-7.8,7.1-7.8,7.1s3.9,18.5,24.6,35.8 c17.3,14.4,32.1,11.9,32.1,11.9s0.7-30.5-1.2-33.2s-19.1-16.8-19.1-16.8L701.4,78.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 704.3483,
    y1: 522.3326,
    x2: 716.6837,
    y2: 522.1909,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC5C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DE8B8B"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M701.5,76.9l-0.3,4.8c0,0,0.6,4,6.1,4.3s9.7-2.3,9.7-2.3V67.6L701.5,76.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 695.7025,
    y1: 536.5,
    x2: 720.2677,
    y2: 536.5,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC5C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DE8B8B"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M697.3,49.8c0,0-1.4,4.8-0.8,6.8c0.6,2.1-0.8,3.7-0.8,5.9c0,2.2,0.5,9.9,1.1,11.3s5.4,3.3,5.4,3.3 s10.3-1.8,11.8-2.6c1.5-0.7,7.6-5.8,6-13.4S709.8,48,709.8,48L697.3,49.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 709.299,
    y1: 511.4551,
    x2: 720.9733,
    y2: 511.3209,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EBEBEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1D0CF"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M706.4,86.1c0.3-0.1,3.4,8.2,3.4,8.2l11.7-8.2l-3.2-5.1L706.4,86.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 698.8264,
    y1: 515.6059,
    x2: 703.9662,
    y2: 515.5469,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EBEBEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1D0CF"
    }
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "701.2,77.2 704.1,85.3 697.4,89.7 697.9,77.9  "
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "704.1,85.3 706.4,86.1 707.9,89.7 706.4,89.7 701.9,117.8 695,110.9 702.3,88.7 701.2,87.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 743.6099,
    y1: 483.2596,
    x2: 723.4366,
    y2: 484.5956,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EBEBEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFEFF"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M735,98.4c0,0-8,5.9-9.1,17.1s-0.6,15.6-0.6,15.6s8.2,1.2,11.5,0.8s5.3-2.3,5.3-2.3S740.4,99.7,735,98.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 686.5729,
    y1: 513.19,
    x2: 679.8929,
    y2: 517.7323,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EBEBEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFEFF"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M688.6,76.8c0,0-2.9,4.5-4.1,9.2c-1.2,4.7-1.1,8.2-1.1,8.2l-4.3-10.8C679,83.5,682.3,75.7,688.6,76.8z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M697.1,46.9c-2.1,2.8-2.8,6.4-1.5,9.5c0.8,2,2.5,4,5.9,5.3c8.3,3.1,13.2,2.2,13.8,0.1c0.6-2.1,5-1.3,2,7.3 c-1.1,3-0.2,3-0.2,6.7s-0.4,6.1-0.4,6.1s4.5,4.8,10.5,10.3c6,5.4,6.1,4.4,6.1,4.4s-5.3-14.5-4.2-24.1c1.1-9.7,1.9-25-8.6-29.3 C711.4,39.4,702.4,39.8,697.1,46.9z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M733.9,402.6L663.5,361c-6.1-3.6-9.9-10.3-9.9-17.4V304h1.4v39.6c0,6.6,3.5,12.8,9.2,16.2l70.4,41.6 L733.9,402.6z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 797.6,
    y: 268.7,
    className: "st28",
    width: 1.4,
    height: 81.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 764.9183,
    y1: 366.45,
    x2: 847.918,
    y2: 366.45,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EBEBEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1D0CF"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M847.9,253c0-0.7-0.1-1.4-0.1-2c0-0.3,0-0.6-0.1-0.9c0-0.1,0-0.3,0-0.4c0-0.2,0-0.5-0.1-0.7 c-0.1-0.7-0.1-1.4-0.2-2.1c-0.1-0.7-0.2-1.4-0.3-2.1c0,0,0,0,0-0.1v-0.1c-0.1-0.7-0.2-1.3-0.3-2s-0.3-1.5-0.4-2.2 c-0.1-0.3-0.1-0.5-0.2-0.8c0-0.2-0.1-0.3-0.1-0.5c-0.1-0.3-0.1-0.6-0.2-1c-0.2-0.7-0.4-1.5-0.6-2.2c-0.1-0.5-0.3-1.1-0.5-1.6 c0-0.1-0.1-0.2-0.1-0.3s-0.1-0.2-0.1-0.3c-0.2-0.7-0.5-1.4-0.7-2.2c-0.2-0.7-0.5-1.4-0.7-2.1c0-0.1-0.1-0.3-0.1-0.4 c0-0.1-0.1-0.2-0.1-0.3c-0.2-0.5-0.3-0.9-0.5-1.3c-0.3-0.7-0.5-1.4-0.8-2c-0.2-0.5-0.4-1-0.6-1.4c0-0.1-0.1-0.2-0.1-0.3 s-0.1-0.2-0.1-0.3c-0.3-0.7-0.6-1.4-0.9-2c-0.3-0.7-0.7-1.5-1.1-2.2c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.1-0.3-0.2-0.4 c-0.3-0.6-0.6-1.2-0.9-1.8c-0.4-0.7-0.8-1.4-1.2-2.1c-0.2-0.4-0.4-0.7-0.6-1.1c-0.1-0.1-0.2-0.3-0.2-0.4c-0.4-0.6-0.8-1.2-1.2-1.9 c-0.6-0.9-1.1-1.8-1.7-2.7c-0.1-0.1-0.2-0.3-0.3-0.4c-0.8-1.3-1.7-2.5-2.6-3.7c0,0,0-0.1-0.1-0.1l0,0c-0.6-0.8-1.2-1.6-1.9-2.5 c-0.5-0.6-1-1.3-1.5-1.9c0,0,0,0,0-0.1l0,0c-0.5-0.6-1.1-1.3-1.6-1.9c-0.5-0.6-1.1-1.2-1.6-1.8c-0.1-0.1-0.2-0.2-0.3-0.3 s-0.2-0.2-0.3-0.3c-0.4-0.4-0.8-0.8-1.2-1.2c-0.6-0.6-1.2-1.2-1.8-1.7c-0.2-0.2-0.4-0.3-0.5-0.5c-0.1-0.1-0.3-0.3-0.4-0.4 c-0.3-0.3-0.6-0.5-0.9-0.8c-0.6-0.6-1.2-1.1-1.9-1.6c-0.3-0.2-0.6-0.5-0.8-0.7c-0.1-0.1-0.3-0.2-0.4-0.3c-0.2-0.2-0.4-0.3-0.6-0.5 c-0.6-0.5-1.2-0.9-1.8-1.4c-0.4-0.3-0.9-0.6-1.3-1c-0.1-0.1-0.2-0.1-0.2-0.2c-0.1-0.1-0.2-0.1-0.2-0.2c-0.6-0.4-1.2-0.8-1.8-1.2 s-1.2-0.7-1.8-1.1c-0.1-0.1-0.3-0.2-0.4-0.2c-0.4-0.3-0.9-0.5-1.3-0.7c-0.2-0.1-0.3-0.2-0.5-0.3s-0.5-0.2-0.7-0.4 c-0.2-0.1-0.4-0.2-0.5-0.3c-0.3-0.1-0.6-0.3-0.8-0.4c-0.2-0.1-0.4-0.2-0.6-0.3c-0.1,0-0.2-0.1-0.2-0.1c-0.6-0.3-1.1-0.5-1.7-0.7 c-0.6-0.2-1.1-0.4-1.7-0.6c-0.1,0-0.1,0-0.2-0.1c-0.2-0.1-0.4-0.1-0.6-0.2c-0.3-0.1-0.6-0.2-0.9-0.3c-0.1,0-0.3-0.1-0.4-0.1 c-0.2-0.1-0.5-0.1-0.7-0.2c-0.2-0.1-0.4-0.1-0.6-0.2c-0.2,0-0.4-0.1-0.6-0.1c-0.2-0.1-0.5-0.1-0.7-0.2c-0.1,0-0.3-0.1-0.4-0.1 c-0.2,0-0.5-0.1-0.7-0.1c-0.3,0-0.6-0.1-0.9-0.1c-0.1,0-0.2,0-0.3,0c-0.2,0-0.5,0-0.7-0.1c-0.3,0-0.6-0.1-0.9-0.1 c-0.1,0-0.2,0-0.3,0c-0.2,0-0.4,0-0.6,0c-0.4,0-0.7,0-1.1,0c-0.1,0-0.2,0-0.3,0c-0.2,0-0.3,0-0.5,0c-0.4,0-0.9,0-1.3,0.1 c-0.1,0-0.3,0-0.4,0c-0.1,0-0.2,0-0.3,0c-0.7,0.1-1.3,0.2-2,0.3c-0.1,0-0.1,0-0.2,0l0,0c-0.9,0.2-1.8,0.4-2.7,0.7 c-0.1,0-0.2,0-0.2,0.1c-0.1,0-0.1,0.1-0.2,0.1c-0.4,0.1-0.7,0.3-1.1,0.5c-0.2,0.1-0.4,0.1-0.5,0.2c-0.5,0.3-1.1,0.5-1.6,0.8 l-11.4,6.6c0.5-0.3,1-0.6,1.6-0.8c0.2-0.1,0.4-0.2,0.5-0.2c0.4-0.2,0.7-0.3,1.1-0.5c0.1-0.1,0.3-0.1,0.4-0.1 c0.9-0.3,1.7-0.5,2.7-0.7c0.1,0,0.1,0,0.2,0c0.6-0.1,1.3-0.2,2-0.3c0.2,0,0.5,0,0.7-0.1c0.4,0,0.9-0.1,1.3-0.1c0.3,0,0.5,0,0.8,0 s0.7,0,1.1,0c0.3,0,0.6,0,0.9,0c0.3,0,0.6,0.1,0.9,0.1c0.3,0,0.7,0.1,1,0.1s0.6,0.1,0.9,0.1c0.4,0.1,0.7,0.1,1.1,0.2 c0.2,0.1,0.5,0.1,0.7,0.2c0.4,0.1,0.8,0.2,1.2,0.3c0.2,0.1,0.5,0.1,0.7,0.2c0.4,0.1,0.9,0.3,1.3,0.4c0.2,0.1,0.4,0.1,0.6,0.2 c1.3,0.4,2.5,0.9,3.8,1.5c0.2,0.1,0.4,0.2,0.6,0.3c0.5,0.2,0.9,0.4,1.4,0.7c0.2,0.1,0.5,0.2,0.7,0.4c0.6,0.3,1.2,0.7,1.8,1 c1.4,0.8,2.8,1.7,4.2,2.7c0.1,0.1,0.2,0.1,0.2,0.2c1.3,0.9,2.6,1.9,3.8,2.9c0.1,0.1,0.3,0.2,0.4,0.3c1.2,1,2.4,2,3.6,3.1 c0.1,0.1,0.3,0.3,0.4,0.4c1.2,1.1,2.3,2.3,3.5,3.5c0.1,0.1,0.2,0.2,0.3,0.3c1.2,1.3,2.4,2.6,3.5,4c0,0,0,0,0,0.1 c1.2,1.4,2.3,2.9,3.4,4.4c0,0,0,0.1,0.1,0.1c1,1.3,1.9,2.7,2.9,4.1c0.6,0.9,1.1,1.8,1.7,2.7c0.5,0.8,1,1.5,1.4,2.3 c0.2,0.4,0.4,0.7,0.6,1.1c0.7,1.3,1.4,2.6,2.1,3.9c0.1,0.1,0.1,0.3,0.2,0.4c0.8,1.6,1.6,3.2,2.3,4.9c0,0.1,0.1,0.2,0.1,0.3 c0.7,1.6,1.3,3.2,1.9,4.8c0,0.1,0.1,0.2,0.1,0.3c0.6,1.7,1.2,3.3,1.7,5c0,0.1,0.1,0.2,0.1,0.3c0.5,1.6,0.9,3.2,1.3,4.8 c0,0.2,0.1,0.3,0.1,0.5c0.4,1.7,0.7,3.3,1,4.9v0.1c0.3,1.7,0.5,3.3,0.6,4.9c0,0.1,0,0.3,0,0.4c0.1,1.6,0.2,3.3,0.2,4.8 c0,0.8,0,1.5-0.1,2.3c0,0.2,0,0.4,0,0.6c0,0.5-0.1,1-0.1,1.5c0,0.3-0.1,0.6-0.1,0.9c0,0.4-0.1,0.8-0.2,1.3c0,0.3-0.1,0.6-0.1,0.9 c-0.1,0.4-0.1,0.8-0.2,1.1c-0.1,0.3-0.1,0.7-0.2,1c-0.1,0.3-0.1,0.7-0.2,1c-0.1,0.4-0.2,0.8-0.3,1.2c-0.1,0.3-0.2,0.6-0.3,0.9 c-0.1,0.5-0.3,0.9-0.4,1.3c-0.1,0.2-0.2,0.5-0.2,0.7c-0.3,0.7-0.6,1.4-0.9,2.1c0,0.1-0.1,0.1-0.1,0.2c-0.4,0.9-0.9,1.8-1.4,2.6 c0,0.1-0.1,0.1-0.1,0.2c-0.4,0.7-0.9,1.3-1.4,1.9c-0.1,0.1-0.2,0.3-0.3,0.4c-0.5,0.6-0.9,1.1-1.4,1.6l-0.1,0.1 c-0.5,0.5-1.1,1-1.7,1.5c-0.1,0.1-0.3,0.2-0.4,0.3c-0.6,0.4-1.2,0.9-1.8,1.2l0,0l0,0l11.4-6.6c0.6-0.4,1.2-0.8,1.8-1.2 c0.1-0.1,0.3-0.2,0.4-0.3c0.6-0.5,1.1-0.9,1.7-1.5l0.1-0.1c0.5-0.5,1-1,1.4-1.6c0.1-0.1,0.2-0.3,0.3-0.4c0.5-0.6,0.9-1.2,1.4-1.9 c0,0,0,0,0-0.1c0,0,0-0.1,0.1-0.1c0.5-0.8,1-1.7,1.4-2.6c0-0.1,0.1-0.1,0.1-0.1s0,0,0-0.1c0.3-0.7,0.6-1.4,0.9-2.1 c0-0.1,0.1-0.1,0.1-0.2c0.1-0.2,0.1-0.3,0.2-0.5c0.2-0.4,0.3-0.9,0.4-1.3c0-0.1,0.1-0.2,0.1-0.4c0-0.2,0.1-0.4,0.1-0.5 c0.1-0.4,0.2-0.8,0.3-1.2c0-0.2,0.1-0.3,0.1-0.5s0.1-0.4,0.1-0.5c0.1-0.3,0.1-0.7,0.2-1c0-0.2,0.1-0.3,0.1-0.5s0.1-0.4,0.1-0.6 c0-0.3,0.1-0.6,0.1-0.9c0-0.2,0-0.3,0.1-0.5c0-0.3,0.1-0.5,0.1-0.8s0.1-0.6,0.1-0.9c0-0.1,0-0.2,0-0.3c0-0.4,0.1-0.8,0.1-1.2 c0-0.2,0-0.4,0-0.6c0-0.1,0-0.1,0-0.2c0-0.7,0-1.3,0-2v-0.1C848,254.3,847.9,253.6,847.9,253z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 752.6435,
    y1: 361.709,
    x2: 836.5438,
    y2: 361.709,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EBEBEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFEFF"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M794.7,189.1c23.2,13.4,41.9,45.8,41.8,72.5c-0.1,26.6-18.9,37.4-42.1,24s-41.8-45.9-41.8-72.5 C752.7,186.4,771.6,175.7,794.7,189.1z"
  })))), /*#__PURE__*/React.createElement("g", null, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M782.6,238.3c0,0-7.6-2.9-14.1-2.1s-7.8,7.1-7.8,7.1s3.9,18.5,24.6,35.8c17.3,14.4,32.1,11.9,32.1,11.9 s0.7-30.5-1.2-33.2c-1.9-2.7-19.1-16.8-19.1-16.8L782.6,238.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 785.5075,
    y1: 362.9331,
    x2: 797.8429,
    y2: 362.7913,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC5C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DE8B8B"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M782.7,236.3l-0.3,4.8c0,0,0.6,4,6.1,4.3s9.7-2.3,9.7-2.3V227L782.7,236.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 776.8435,
    y1: 377,
    x2: 801.4087,
    y2: 377,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC5C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DE8B8B"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M778.4,209.2c0,0-1.6,4.6-1,6.7c0.6,2.1-0.6,3.9-0.6,6.1c0,2.2,0.5,9.9,1.1,11.3c0.6,1.4,5.4,3.3,5.4,3.3 s10.3-1.8,11.8-2.6s7.6-5.8,6-13.4c-1.6-7.6-10.2-13.1-10.2-13.1L778.4,209.2z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M787.6,245.4c0.3-0.1,3.4,8.2,3.4,8.2l11.7-8.2l-3.2-5.1L787.6,245.4z"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st65",
    points: "782.4,236.6 785.3,244.6 778.6,249.1 779.1,237.2  "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M816.1,257.7c0,0-8,5.9-9.1,17.1s-0.6,15.6-0.6,15.6s8.2,1.2,11.5,0.8c3.3-0.4,5.3-2.3,5.3-2.3 S821.6,259,816.1,257.7z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M769.8,236.2c0,0-2.9,4.5-4.1,9.2c-1.2,4.7-1.1,8.2-1.1,8.2l-4.3-10.8C760.1,242.8,763.5,235,769.8,236.2z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M787.6,212.8c0,0-2.5,2.8-5.6,4.1c-3.1,1.2-5.1,3.8-5.1,3.8s-5-7.4,0.3-13.2s11.8-10.1,19.2-8.5 s8.9,8.5,8.9,8.5s8.2,3.9,2.4,12.9c-5.7,9-8.1,11.4-9.1,10.5s2.4-7.7,0-8.8s-2.8,1.6-2.7,3.9c0.1,2.3-0.9,3.6-1.9,2.8 s2-10.5-4.9-10.6C785.1,218,787.6,212.8,787.6,212.8z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M797.9,178.4h-1.4v-25.3c0-2,1-3.8,2.8-4.8c1.7-1,3.8-1,5.6,0l23.5,13.8c1.8,1.1,4.1,1.1,5.9,0 c1.9-1.1,3-3,3-5.1v-21h1.4v21c0,2.6-1.4,5-3.7,6.3s-5,1.3-7.3,0l-23.5-13.8c-1.3-0.8-2.9-0.8-4.2,0s-2.1,2.1-2.1,3.6V178.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 933.2224,
    y1: 458.2181,
    x2: 933.2224,
    y2: 527.7948,
    gradientTransform: "matrix(1 0 0 -1 -92.5289 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EBEBEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFEFF"
    }
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st66",
    points: "875.4,66.5 805.9,26.7 805.9,119.2 875.4,159  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 902.2857,
    y1: 580.9041,
    x2: 980.7178,
    y2: 514.344,
    gradientTransform: "matrix(1 0 0 -1 -92.5289 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFAC06"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF460E"
    }
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st67",
    points: "878.7,64.9 875.4,66.5 805.9,26.7 809.3,25.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 967.9307,
    y1: 487.1,
    x2: 971.3098,
    y2: 487.1,
    gradientTransform: "matrix(1 0 0 -1 -92.5289 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFAEAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ADADAD"
    }
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st68",
    points: "875.4,159 878.7,157.4 878.7,64.9 875.4,66.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 925.3724,
    y1: 689.8098,
    x2: 925.3724,
    y2: 693.4523,
    gradientTransform: "matrix(1 0.5647 0 -1 -92.5289 238.8464)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B8B8B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFEFF"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M847.9,80.5l-30.2-17c-1.1-0.6-2.1-2.1-2.1-3.2l0,0c0-1.1,0.9-1.5,2.1-0.9l30.2,17c1.1,0.6,2.1,2.1,2.1,3.2 l0,0C850,80.8,849.1,81.2,847.9,80.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 934.7724,
    y1: 681.2661,
    x2: 934.7724,
    y2: 684.9092,
    gradientTransform: "matrix(1 0.5647 0 -1 -92.5289 238.8464)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B8B8B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFEFF"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M866.5,99.6L817.8,72c-1.1-0.6-2.1-2.1-2.1-3.2l0,0c0-1.1,0.9-1.5,2.1-0.9l48.8,27.5 c1.1,0.6,2.1,2.1,2.1,3.2l0,0C868.6,99.8,867.7,100.2,866.5,99.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 934.6724,
    y1: 672.723,
    x2: 934.6724,
    y2: 676.3663,
    gradientTransform: "matrix(1 0.5647 0 -1 -92.5289 238.8464)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B8B8B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFEFF"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M866.5,108.1l-48.8-27.5c-1.1-0.6-2.1-2.1-2.1-3.2l0,0c0-1.1,0.9-1.5,2.1-0.9l48.8,27.5 c1.1,0.6,2.1,2.1,2.1,3.2l0,0C868.6,108.4,867.7,108.8,866.5,108.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 934.6724,
    y1: 664.1801,
    x2: 934.6724,
    y2: 667.8232,
    gradientTransform: "matrix(1 0.5647 0 -1 -92.5289 238.8464)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B8B8B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFEFF"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M866.5,116.7l-48.8-27.5c-1.1-0.6-2.1-2.1-2.1-3.2l0,0c0-1.1,0.9-1.5,2.1-0.9l48.8,27.5 c1.1,0.6,2.1,2.1,2.1,3.2l0,0C868.6,116.9,867.7,117.3,866.5,116.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 931.4724,
    y1: 655.6373,
    x2: 931.4724,
    y2: 659.2803,
    gradientTransform: "matrix(1 0.5647 0 -1 -92.5289 238.8464)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B8B8B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFEFF"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M860,121.5l-42.2-23.8c-1.1-0.6-2.1-2.1-2.1-3.2l0,0c0-1.1,0.9-1.5,2.1-0.9l42.2,23.8 c1.1,0.6,2.1,2.1,2.1,3.2l0,0C862,121.7,861.1,122.1,860,121.5z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 933.2224,
    y1: 527.1,
    x2: 933.2224,
    y2: 570.8176,
    gradientTransform: "matrix(1 0 0 -1 -92.5289 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFAC06"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5703,
    style: {
      stopColor: "#FF720B"
    }
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "805.9,36.3 875.4,76.2 875.4,66.5 805.9,26.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 976.4678,
    y1: 523.456,
    x2: 961.6766,
    y2: 534.3548,
    gradientTransform: "matrix(1 0 0 -1 -92.5289 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFAC06"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF460E"
    }
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "875.4,66.5 878.7,64.9 878.7,74.6 875.4,76.2  "
  }))), /*#__PURE__*/React.createElement("g", null, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 703.9,
    cy: 552,
    rx: 53.3,
    ry: 29.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 703.9,
    cy: 552,
    rx: 52.2,
    ry: 29.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 703.9,
    cy: 552,
    rx: 51.2,
    ry: 28.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 703.9,
    cy: 552,
    rx: 50.2,
    ry: 28.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st7",
    cx: 703.9,
    cy: 552,
    rx: 49.2,
    ry: 27.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 703.9,
    cy: 552,
    rx: 48.1,
    ry: 27
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 703.9,
    cy: 552,
    rx: 47.1,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st10",
    cx: 703.9,
    cy: 552,
    rx: 46.1,
    ry: 25.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st11",
    cx: 703.9,
    cy: 552,
    rx: 45.1,
    ry: 25.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st12",
    cx: 703.9,
    cy: 552,
    rx: 44,
    ry: 24.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st13",
    cx: 703.9,
    cy: 552,
    rx: 43,
    ry: 24.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st14",
    cx: 703.9,
    cy: 552,
    rx: 42,
    ry: 23.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st15",
    cx: 703.9,
    cy: 552,
    rx: 41,
    ry: 23
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st16",
    cx: 703.9,
    cy: 552,
    rx: 39.9,
    ry: 22.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st17",
    cx: 703.9,
    cy: 552,
    rx: 38.9,
    ry: 21.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st18",
    cx: 703.9,
    cy: 552,
    rx: 37.9,
    ry: 21.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st19",
    cx: 703.9,
    cy: 552,
    rx: 36.9,
    ry: 20.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st20",
    cx: 703.9,
    cy: 552,
    rx: 35.9,
    ry: 20.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st21",
    cx: 703.9,
    cy: 552,
    rx: 34.8,
    ry: 19.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st22",
    cx: 703.9,
    cy: 552,
    rx: 33.8,
    ry: 18.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st23",
    cx: 703.9,
    cy: 552,
    rx: 32.8,
    ry: 18.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st24",
    cx: 703.9,
    cy: 552,
    rx: 31.8,
    ry: 17.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st25",
    cx: 703.9,
    cy: 552,
    rx: 30.7,
    ry: 17.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st26",
    cx: 703.9,
    cy: 552,
    rx: 29.7,
    ry: 16.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st27",
    cx: 703.9,
    cy: 552,
    rx: 28.7,
    ry: 16.1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 648.0436,
    y1: 70.3002,
    x2: 755.0436,
    y2: 70.3002,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EBEBEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1D0CF"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M754.9,507c0,0.3,0,0.5-0.1,0.8c0,0.2-0.1,0.5-0.1,0.7c0,0.3-0.1,0.5-0.1,0.8c0,0.2-0.1,0.5-0.1,0.7 c-0.1,0.3-0.1,0.5-0.2,0.8c-0.1,0.2-0.1,0.5-0.2,0.7c-0.1,0.3-0.2,0.5-0.3,0.8c-0.1,0.2-0.2,0.5-0.3,0.7 c-0.1,0.3-0.2,0.5-0.3,0.8c-0.1,0.2-0.2,0.5-0.3,0.7c-0.1,0.3-0.3,0.5-0.4,0.8c-0.1,0.2-0.2,0.4-0.4,0.6 c-0.2,0.3-0.4,0.6-0.6,0.9c-0.1,0.2-0.2,0.4-0.4,0.6c-0.2,0.3-0.5,0.7-0.8,1c-0.1,0.2-0.2,0.3-0.3,0.5c-0.4,0.5-0.9,1.1-1.4,1.6 c-0.1,0.1-0.3,0.3-0.4,0.4c-0.4,0.4-0.8,0.8-1.2,1.2c-0.2,0.2-0.4,0.4-0.6,0.5c-0.3,0.2-0.5,0.4-0.8,0.7 c-0.2,0.2-0.5,0.4-0.7,0.6c-0.3,0.2-0.6,0.4-0.8,0.7c-0.3,0.2-0.5,0.4-0.8,0.6c-0.3,0.2-0.6,0.4-0.9,0.6 c-0.3,0.2-0.6,0.4-0.8,0.6c-0.3,0.2-0.6,0.4-1,0.6c-0.4,0.3-0.8,0.5-1.2,0.8c-1.2,0.7-2.4,1.3-3.6,1.9c-0.3,0.2-0.7,0.3-1,0.5 c-1.1,0.5-2.3,1-3.4,1.5c-0.2,0.1-0.3,0.1-0.5,0.2c-1.2,0.5-2.5,0.9-3.8,1.3c-0.9,0.3-1.8,0.5-2.8,0.8c-0.7,0.2-1.4,0.4-2.1,0.6 c-1,0.2-2,0.4-3,0.6c-0.7,0.1-1.4,0.3-2.2,0.4c-0.3,0.1-0.6,0.1-0.9,0.1c-1.2,0.2-2.5,0.4-3.7,0.5c-0.4,0-0.7,0.1-1.1,0.1 c-0.7,0.1-1.4,0.1-2.1,0.2c-1.2,0.1-2.4,0.2-3.6,0.2c-0.8,0-1.5,0-2.3,0.1c-1,0-2,0-2.9,0c-0.8,0-1.6,0-2.5-0.1 c-0.9,0-1.8-0.1-2.7-0.1c-0.8-0.1-1.7-0.1-2.5-0.2c-0.9-0.1-1.8-0.2-2.7-0.3c-0.8-0.1-1.6-0.2-2.4-0.3c-1-0.1-1.9-0.3-2.8-0.5 c-0.7-0.1-1.5-0.3-2.2-0.4c-1.1-0.2-2.2-0.5-3.3-0.8c-0.7-0.2-1.4-0.4-2.1-0.6c-0.4-0.1-0.8-0.2-1.1-0.4 c-1.1-0.3-2.2-0.7-3.3-1.1c-0.3-0.1-0.6-0.2-0.9-0.3c-1-0.4-1.9-0.8-2.8-1.2c-0.5-0.2-0.9-0.4-1.4-0.6c-1.3-0.6-2.7-1.3-3.9-2 c-10.5-6.1-15.8-14.1-15.8-22.1v15.2c0,8,5.2,16,15.8,22.1c1.3,0.7,2.6,1.4,3.9,2c0.4,0.2,0.9,0.4,1.4,0.6c0.8,0.4,1.6,0.7,2.4,1 c0.1,0.1,0.3,0.1,0.4,0.2c0.3,0.1,0.6,0.2,0.9,0.3c1.1,0.4,2.1,0.8,3.2,1.1c0.4,0.1,0.8,0.2,1.1,0.4c0.3,0.1,0.5,0.2,0.8,0.2 c0.4,0.1,0.9,0.2,1.4,0.3c1.1,0.3,2.2,0.6,3.3,0.8c0.3,0.1,0.6,0.2,0.9,0.2c0.4,0.1,0.9,0.1,1.3,0.2c0.9,0.2,1.9,0.3,2.8,0.5 c0.4,0.1,0.8,0.1,1.1,0.2c0.4,0.1,0.8,0.1,1.3,0.1c0.9,0.1,1.8,0.2,2.7,0.3c0.4,0,0.8,0.1,1.3,0.1c0.4,0,0.8,0,1.2,0.1 c0.9,0.1,1.8,0.1,2.7,0.1c0.5,0,0.9,0.1,1.4,0.1c0.4,0,0.7,0,1.1,0c1,0,2,0,2.9,0c0.5,0,1,0,1.5,0c0.3,0,0.6,0,0.9-0.1 c1.2-0.1,2.4-0.1,3.6-0.2c0.5,0,1,0,1.5-0.1c0.2,0,0.5-0.1,0.7-0.1c0.4,0,0.7-0.1,1.1-0.1c1.2-0.1,2.5-0.3,3.7-0.5 c0.3,0,0.6-0.1,0.9-0.1c0.1,0,0.3,0,0.4-0.1c0.6-0.1,1.1-0.3,1.7-0.4c1-0.2,2-0.4,2.9-0.6c0.7-0.2,1.4-0.4,2.1-0.6 c0.9-0.3,1.8-0.5,2.8-0.8c0.2-0.1,0.4-0.1,0.6-0.2c1.1-0.4,2.2-0.7,3.2-1.1c0.2-0.1,0.3-0.1,0.4-0.2c1.2-0.5,2.3-0.9,3.4-1.5 c0.3-0.2,0.7-0.3,1-0.5c1.2-0.6,2.4-1.2,3.6-1.9c0.2-0.1,0.4-0.3,0.7-0.4c0.2-0.1,0.4-0.2,0.6-0.4c0.3-0.2,0.7-0.4,1-0.6 c0.3-0.2,0.6-0.4,0.8-0.6c0.3-0.2,0.6-0.4,0.9-0.6c0.3-0.2,0.5-0.4,0.8-0.6c0.3-0.2,0.6-0.4,0.8-0.7c0.3-0.2,0.5-0.4,0.7-0.6 c0.3-0.2,0.5-0.4,0.8-0.7c0.1-0.1,0.2-0.2,0.3-0.3s0.2-0.2,0.3-0.3c0.4-0.4,0.8-0.8,1.2-1.2c0.1-0.1,0.3-0.3,0.4-0.4 c0.5-0.5,1-1.1,1.4-1.6c0,0,0,0,0.1-0.1s0.2-0.3,0.3-0.4c0.3-0.3,0.5-0.7,0.8-1c0.1-0.2,0.2-0.4,0.4-0.6c0.2-0.3,0.4-0.6,0.6-0.9 c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.1-0.3,0.2-0.4c0.1-0.3,0.3-0.5,0.4-0.8c0.1-0.2,0.2-0.4,0.3-0.7s0.2-0.5,0.3-0.8 c0-0.1,0.1-0.2,0.2-0.4c0-0.1,0.1-0.2,0.1-0.3c0.1-0.3,0.2-0.5,0.3-0.8c0.1-0.2,0.1-0.5,0.2-0.7c0.1-0.3,0.1-0.5,0.2-0.8 c0-0.1,0.1-0.3,0.1-0.4c0-0.1,0-0.2,0-0.3c0-0.3,0.1-0.5,0.1-0.8c0-0.2,0.1-0.5,0.1-0.7c0-0.3,0-0.5,0.1-0.8c0-0.2,0-0.3,0-0.5 s0-0.3,0-0.5v-15.2C755,506.2,755,506.7,754.9,507z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 698.8113,
    y1: 119.0971,
    x2: 704.6317,
    y2: 64.1667,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F6F6F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M739.2,484c-21-12.1-54.8-12.1-75.6,0s-20.7,31.7,0.2,43.8c21,12.1,54.8,12.1,75.6,0 C760.3,515.7,760.1,496.1,739.2,484z"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "729.1,496 715.2,504.1 729.2,512 715.5,520 701.5,512 687.6,520 673.9,512 687.7,504 673.8,496  687.5,488 701.4,496.1 715.3,488  "
  }))))), /*#__PURE__*/React.createElement("g", null, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M238,484.3c-37.7,10.4-98.8,10.4-136.5,0c-37.7-10.4-37.7-27.4,0-37.8c37.7-10.4,98.8-10.4,136.5,0 C275.7,456.9,275.7,473.8,238,484.3z"
  })), /*#__PURE__*/React.createElement("g", null, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M194.5,253c0,0,10.7,1.1,15,0.5c3.1-0.4,5.8-4.9,5.3-7.4c-0.5-2.6-9.4-6.8-17.6-7.9 C190.8,237.4,193.5,252.2,194.5,253z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M162.1,247.2c18.8,13.4,33.2,12.7,33.2,12.7s4.4-4.6,6.9-13.6c1.9-6.8,1.7-10,1.7-10s-20-8.8-35.6-16.5 c-0.9-0.5-8.2,1.1-10.7,9.3C154.4,239.6,158.4,244.5,162.1,247.2z"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M124.6,182.2c2.2-7.7-18-13.7-18.3,0.2c-0.5,25.8,0.5,53.2-7,50.2c-5.2-2.1-21.8-23.8-35.4-2.3 c-20.2,32,35.9,54.2,52,30.7C130.2,239.9,117.6,206.8,124.6,182.2z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M130.5,183c0,0-5.6-0.8-6.8-0.9c-1.1-0.1-4.1,3.4-4.1,8.7c0,5.3,2.1,9.3,3.7,9.6c1.7,0.3,6.6,0.7,6.6,0.7 s5.1-2.5,5-8.5C134.7,186.6,130.5,183,130.5,183z"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M239,452.5c0,0-18.4,0.8-19.8,0.8c-1.5,0-3.9-0.1-2.8,4.5c1.1,4.6,1.4,6.1,1.4,6.1s19.8-6,21.8-6.9 C241.7,456.1,242.9,454,239,452.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M223.3,454.8c0,0-0.9,1.5-2.4,1.7c-2.2,0.2-2.8-0.9-2.8-0.9s-2.8-12.4-6.9-20c-1.8-3.4-7-15.1-12.5-27.9 l17-4.8C218.6,424.8,223.3,454.8,223.3,454.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M190.7,346.9c11.5-3.5,18.6,0.5,19.7,6.9c2.3,14.5,1.4,14.8,3.7,32.4c0.5,4.1,1.5,11.1,2.5,16.8l-18.6,5.8 c-6.8-15.8-13.3-34.5-15.5-40C178.5,359,179.1,350.4,190.7,346.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M174.3,286.7c0,0,31.3,50,35.4,64.7c3.2,11.3-12.5,22.2-26.1,13c-13.6-9.3-32.1-22.4-40.7-35.3 c-8.6-12.9-12-24.8-7.7-38.6C139.6,276.8,165.9,273.4,174.3,286.7z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M154.4,294.1c0,0,11.2,57.7,12.9,69.4c1.8,11.6-19.9,18.7-29.1,5.1c-9.2-13.6-21.7-32.6-25-47.7 c-3.3-15.1-2.1-27.5,7-38.7C129.3,270.9,151.5,278.6,154.4,294.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M128.8,459.3c0,0-17.8-4.8-19.1-5.2c-1.4-0.5-3.7-1.3-4,3.4c-0.3,4.7-0.5,6.2-0.5,6.2s20.7,0.3,22.9,0 C130.3,463.5,132.1,461.9,128.8,459.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M113.6,457.6c0,0-1.7,0.6-3-0.2c-1.9-1.2-1.6-2.5-1.6-2.5s5.5-11.4,7.1-20c0.7-3.8,3.9-16.2,7.6-29.6 l16.3,6.8C128.6,431.2,113.6,457.6,113.6,457.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M155.2,352.9c11.2,4.5,14.3,12,11.1,17.6c-7.2,12.8-8.1,12.4-17.3,27.7c-2.1,3.5-5.7,9.6-8.5,14.7l-18.2-7 c4.5-16.6,11-35.3,12.7-40.9C138.1,354.8,144,348.4,155.2,352.9z"
  })))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M164.2,205.2c3.1-3.3,3.1-12.2,1.3-16.8c-2.5-6.1-5.3-15.5-23.4-12.6c-12.4,2-22.5,15.8-11.7,34.9 C136.6,221.8,158.6,211.2,164.2,205.2z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M172.6,226.8c-0.5-4.8-2.5-8-11.4-8.3c-4.6-0.1-14.7,0.9-19,1.1c-14.9,1-20,6.5-24.6,22.1 c-8.5,29.1-6.8,74.7-6.8,74.7s2,5.9,42.1,3.1c29.3-2,37.5-10.2,37.5-10.2s-10.2-17.2-12.3-31.9c10.1-2.5,10.6-6.4,10.9-11.7 C189.5,257.4,174.8,249.8,172.6,226.8z"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M149.4,217.7c-6.5,0.6-14.1-2.3-14.5,2.3c-0.4,4.6,5,21.4,15.5,25.9c10.5,4.4,18.5-0.2,17.7-5.7 c-0.8-5.5-3.3-11.3-4.6-15.6c-1.3-4.3,0.3-8.7-4.3-8.4C154.5,216.4,153,217.4,149.4,217.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M154.4,218.8c-4.6,0.1-7.9,0.6-12.3,0.9c-1.3,0.1-2.5,0.2-3.6,0.3c1.4,6.4,6.4,26.6,21,24 c11-2,3.2-5.2,0.1-25.2C158.1,218.7,156.4,218.7,154.4,218.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M141.8,221.6c1.3-9.2,3.1-15.1,5.4-23.6c0-0.3,13.2-1,15.7-7.6c0,0,1.7,8,1.3,14.8 c-0.4,6.4-1.9,10.1-8.4,7.7c-1,3.7,0.2,5.3,0.8,8.6c1,5.4-2.4,8.1-4.9,8.6C149.2,230.7,140.4,231.7,141.8,221.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M141.8,221.6c1.3-9.2,3.1-15.1,5.4-23.6c0-0.3,13.2-1,15.7-7.6c0,0,1.7,8,1.3,14.8 c-0.4,6.4-1.9,10.1-8.4,7.7c-1,3.7,0.2,5.3,0.8,8.6c1,5.4-2.4,8.1-4.9,8.6C149.2,230.7,140.4,231.7,141.8,221.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M141.6,199.7c-0.8,1.6,0.6,3.8,2.9,4.9c2.4,1.1,4.9,0.7,5.7-0.9c0.8-1.6-0.6-3.8-2.9-4.9 C144.9,197.7,142.4,198.1,141.6,199.7z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M225.7,193.8c-0.8-1.5-3-6.4-1.8-7c2.8-1.5,2.6,1.9,6.2,3.9c2.3,1.3,0.4,8.2,0.4,8.2S227.4,197,225.7,193.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M204.8,243.4c3.2-13.2,23.1-39.7,23.8-46.1c0.4-4.1-2-4.7,0.2-12.3c1.6-5.9,18.9-1.6,14.9,1.6 c-5.4,4.2-0.7,10.6-9.3,12.8c-2.5,2.7-12.7,34.4-16.2,43c-1.6,3.9-4.4,9.6-7.4,9.1C206,250.8,203.6,248.3,204.8,243.4z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M100,260.1c0,0-5.7,12.9-6.5,17.1c-0.6,3,4.2,3.9,6.8,4.3c2.6,0.3,9.4-6.8,12.9-14.3 C115.9,261.5,101,259.4,100,260.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M126.6,224.6c-22.3,12.5-34.4,38.8-34.4,38.8s3.5,6,10.5,9.2c6.4,2.9,10.1,2.1,10.1,2.1s4.9-4.3,14-15.5 c2.7-3.4,4.6-13.7,4.7-20.5C131.6,232.3,132.9,221,126.6,224.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M149.6,305.4c-0.3,1.3,0.5,2.2,1.8,2.2h38c1.3,0,2.7-1,3-2.2l12.2-50.7c0.3-1.3-0.5-2.4-1.8-2.4h-38 c-1.3,0-2.7,1.1-3,2.4L149.6,305.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 5707.6401,
    y1: 300.9649,
    x2: 5707.6401,
    y2: 215.529,
    gradientTransform: "matrix(1 0 0 1 -5549.2861 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A0A0A0"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M149.6,305.4l12.2-50.7c0.3-1.3,1.7-2.4,3-2.4h2.3c-1.3,0-2.7,1.2-3,2.5l-12.2,50.6 c-0.3,1.3,0.5,2.3,1.8,2.3h-2.3C150.1,307.6,149.3,306.7,149.6,305.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: -3996.8562,
    y1: 272.1698,
    x2: -3996.8562,
    y2: 294.056,
    gradientTransform: "matrix(1 0 0 1 4175.0771 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDC300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1689,
    style: {
      stopColor: "#FCB200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7267,
    style: {
      stopColor: "#FA7E00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F96A00"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M184.2,280.2c0.9-3.9-1.1-7.1-4.4-7.1c-3.3,0-6.7,3.2-7.5,7.1c-0.9,3.9,1.1,7.1,4.4,7.1 C179.9,287.2,183.3,284.1,184.2,280.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 15644.6543,
    y1: 273.6494,
    x2: 15644.6543,
    y2: 305.9794,
    gradientTransform: "matrix(1 0 0 1 -15468.0283 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8F8F8F"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M175.2,280.2c0.7-3.3,3.3-6.1,6-6.9c-0.4-0.1-0.9-0.2-1.4-0.2c-3.3,0-6.7,3.2-7.5,7.1 c-0.9,3.9,1.1,7.1,4.4,7.1c0.5,0,1-0.1,1.5-0.2C175.7,286.2,174.4,283.5,175.2,280.2z"
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M99.6,273c13.6-0.6,44.6,11.3,50.9,10.1c4.1-0.7,4.1,13.7-0.4,6.1c-3.3-1.6-36.5-2.7-45.8-3.7 c-4.2-0.5-10.4-1.6-10.8-4.6C92.8,276.1,94.6,273.2,99.6,273z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M150.7,280.1c0.8-1.6,4-4.2,5.1-3.3c2.3,1.7-1.5,3-2.3,7.2c-0.6,2.7-4.7,3.2-4.7,3.2 S149.1,283.4,150.7,280.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M154,295.5c-4.4,0.4-5.9-0.8-5.4-4.8c0.2-1.9,0.2-5.7,1-7.6c1.3-3,0.9-4.2,8.4-0.8 C161.6,283.9,158,295.2,154,295.5z"
  })))))), /*#__PURE__*/React.createElement("g", null, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M465.5,579.5c-37.7,10.4-98.8,10.4-136.5,0c-37.7-10.4-37.7-27.4,0-37.8s98.8-10.4,136.5,0 S503.1,569,465.5,579.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 378.3456,
    y1: 366.0134,
    x2: 378.3456,
    y2: 492.8959
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F1E2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#082947"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M404,385.2c0,0-13.1,64.5-15.7,75.9c-2.6,11.4-25.1,10.1-28.7-5.8c-3.6-15.9-10.3-41.8-5-81.3 C357,355.3,406.8,369.7,404,385.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 375.2982,
    y1: 366.2546,
    x2: 375.2982,
    y2: 492.8379
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F1E2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#082947"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M361,474.4c-1.4-10.2-1.6-31.5,10-32.1c11.7-0.7,19.3,7.2,19.2,9.2c-0.8,10.5-4.4,43.3-7.9,68.6h-14.5 C365.2,505.3,362.1,482.1,361,474.4z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M368.3,520.1h13.4c-2.4,17-4.3,31.2-4.3,31.2s-0.4,0.7-2.5,0.4c-2.1-0.3-2.4-1.6-2.4-1.6s0.1-11.4-2-19.5 C369.9,528.5,369.2,524.5,368.3,520.1z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M386.3,551.7c-6.1-2.2-10.4-2.8-11.7-3.2c-1.4-0.4-3.7-1.3-3.9,3.4c-0.3,4.7-0.4,6.1-0.4,6.1 s16.8,0,19-0.2C391.4,557.6,389.9,553,386.3,551.7z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M433.8,381.4c0,0-1,59.5-1.7,71.3c-0.7,11.9-23.6,14.4-29.9-1c-6.3-15.4-14.7-36.8-14.7-52.5 c-0.1-15.7,3.7-27.6,15-36.9C413.8,353.1,434.1,365.4,433.8,381.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M413.5,440.3c11.8-2,18.3,2.8,18.5,9.2c0.5,14.6-0.5,14.8-0.4,32.4c0,8.3,0.7,23.9,0.9,38.1h-13.7 c-5.4-18.1-14-51.1-16.1-59.1C400.1,450.8,401.7,442.3,413.5,440.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M432.2,550.4c0,0-1.1,1.4-2.6,1.3c-2.2,0-2.6-1.3-2.6-1.3s-1.3-12.4-4.3-20.5c-0.6-1.7-1.8-5.6-3.2-10 h12.4C432.1,536,432.2,550.4,432.2,550.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M441.1,551.7c-6.1-2.2-10.4-2.8-11.7-3.2c-1.4-0.4-3.7-1.3-3.9,3.4c-0.3,4.7-0.4,6.1-0.4,6.1 s16.8,0,19-0.2C446.2,557.6,444.7,553,441.1,551.7z"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M401.5,348.7c12.6-2.5,42.7-2.1,53.3-2.1l0.5,5.6c-9.2,0.9-37,7-45.6,8.3c-4.4,0.6-11.2,1.1-12.4-1.9 C395.3,353.8,396.2,349.8,401.5,348.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M400.7,339c0,0,5.5,13.4,6.5,17.7c0.7,3.1-3.7,3.6-6.3,4c-2.6,0.4-9.7-6.7-13.4-14.2 C384.6,340.7,399.7,338.3,400.7,339z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M377,295.4c8.5,11.2,29.1,49.8,29.1,49.8s-1.7,3.6-8.4,7.6c-10.1,6-15.1,5.2-15.1,5.2s-7.6-9-15.7-20.7 c-4-5.8-6.6-12.2-3.6-27C365.2,301.2,371.9,288.7,377,295.4z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M456,346.6c-0.4-1.8-1.6-7.9,0.2-7.7c3.4,0.4,2.1,2.7,5.2,5.8c2,2-1.8,7.4-1.8,7.4S456.8,350.3,456,346.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M452.9,346.7c7.6,0,5.5,0.6,9.4-6.8c1.9-3.6,14.2-1.6,14.2,2.5c0,7.6-1.4,10.5-7.9,11.1 c-5,0.5-10.8-1.9-14.3-1.3C454.3,352.3,452.5,346.7,452.9,346.7z"
  }))), /*#__PURE__*/React.createElement("g", null, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M424.3,344c-0.4,1.5,0.6,2.7,2.2,2.7h56.1c1.6,0,3.1-1.2,3.5-2.7l9.7-40c0.4-1.5-0.6-2.8-2.2-2.8h-56.1 c-1.6,0-3.1,1.2-3.5,2.8L424.3,344z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 4414.3428,
    y1: 379.2637,
    x2: 4360.2046,
    y2: 325.1255,
    gradientTransform: "matrix(-1 0 0 1 4818.6953 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#828184"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M434,303.9c0.4-1.5,1.9-2.8,3.5-2.8h56.1c1.6,0,2.5,1.2,2.2,2.8l-9.7,40h-61.8L434,303.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 4330.7002,
    y1: 272.1776,
    x2: 4330.7002,
    y2: 341.8412,
    gradientTransform: "matrix(-1 0 0 1 4818.6953 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#828184"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M483.6,344l9.7-40c0.4-1.5-0.6-2.8-2.2-2.8h2.5c1.6,0,2.5,1.3,2.2,2.8l-9.7,40c-0.4,1.5-1.9,2.7-3.5,2.7 h-2.5C481.7,346.7,483.3,345.5,483.6,344z"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    className: "st91"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M480.8,341.7c0.6,0,1.2-0.5,1.4-1l8.8-36.3c0.1-0.6-0.2-1.1-0.8-1.1h-52.6c-0.6,0-1.2,0.5-1.4,1.1 l-8.8,36.3c-0.1,0.6,0.2,1.1,0.8,1.1H480.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 6983.2012,
    y1: 341.0152,
    x2: 6983.2012,
    y2: 300.7714,
    gradientTransform: "matrix(-1 0 0 1 7442.3359 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#828184"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M480.8,341.7c0.6,0,1.2-0.5,1.4-1l8.8-36.3c0.1-0.6-0.2-1.1-0.8-1.1h-52.6c-0.6,0-1.2,0.5-1.4,1.1 l-8.8,36.3c-0.1,0.6,0.2,1.1,0.8,1.1H480.8z"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M396.3,346.7c-0.6,0-1-0.4-1-1V345c0-0.6,0.5-1,1-1h86c0.6,0,0.7,0.5,0.7,1v0.7c0,0.6-0.2,1-0.7,1H396.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 4311.1567,
    y1: 345.313,
    x2: 4421.1851,
    y2: 345.313,
    gradientTransform: "matrix(-1 0 0 1 4818.6953 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#828184"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M396.3,343.9h55.3c-0.6,0-1.4,0.5-1.4,1v0.7c0,0.6,0.9,1,1.4,1h-55.3c-0.6,0-1-0.4-1-1V345 C395.3,344.4,395.8,343.9,396.3,343.9z"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M385.6,286.3c2.5-10.8,4.3-12.4,7.5-20.6c0-0.3,12.5,1.7,15.6-4.7c0,0,1,8.2-0.1,15c-1,6.4-2.9,9.9-9.2,6.9 c0,3.1-0.9,6.7-0.9,9.5c0.1,5.5-3.7,6.8-6.3,6.5C389.6,298.7,383.3,296.4,385.6,286.3z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M404.9,288.6c1.5,5.4,6.4,17.2-6.7,17.7c-15.4,0.6-20.1-15-19.4-16.9c1.6-4.3,7.9-2.6,11.8-2.7 C394.5,286.6,403.6,284,404.9,288.6z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M402.8,289c13.8-0.3,17,5.6,19.5,19.3c6.4,34.9,11.1,62.1,13.6,79.7c-0.8,4.8-8.1,12.3-37.8,13.2 c-38.5,1.2-46.7-5.2-46.7-5.2s2.8-62,11.9-89.6c4.4-13.4,11.9-15.6,27.1-17.3C394.8,288.7,398.2,289.1,402.8,289z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M409,266.9c6.4-0.9,8.8-21.2-1.3-22.5c-13.3-1.8-7.9,8.6-14,8.3c-17.9-0.9-19.8,6.1-17.1,16 c2.2,7.9,5.4,13.3,12,13.1c2.7-0.1,6.7,1.5,9.4-9.5C399.8,265.4,403.1,267.8,409,266.9z"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M485.6,281.4c1.1-1.4,5-5.6,6.1-4.7c2.2,1.6-0.4,3.4-1.2,7.7c-0.7,3.9-6.2,4.9-6.2,4.9 S483.2,284.4,485.6,281.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M449.9,335.9c4.4-13.8,29.7-43.7,30.9-50.4c0.8-4.4-4.1-6.7,3.4-13.4c3-2.7,12.6-2.7,12,0.4 c-0.6,2.6-4.3,0.5-7.7,4.4c-1.3,1.5,0.5,6.7-1.7,11.2c-1.7,3.5-16.1,35.5-20.6,44.4c-3.2,6.9-6.5,10.8-9.6,10.2 C452,341.9,448.2,341,449.9,335.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M450.8,321.8c0,0,9,11.4,11,15.2c1.5,2.8-2.5,4.5-5,5.6c-2.4,1.1-11.1-3.8-16.8-10 C435.8,327.9,449.6,321.4,450.8,321.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M415.7,292.3c12,7.4,39.9,32.1,39.9,32.1s0.7,5.2-4.7,10.9c-8,8.6-12.3,9.8-12.3,9.8s-8.6-6.1-19.6-15.2 c-5.4-4.4-9-5.9-10.9-22.2C407.1,298.5,407.3,287.1,415.7,292.3z"
  }))))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M394.1,269.1c-1.3,1.2-1,3.8,0.8,5.7c1.8,2,4.3,2.6,5.6,1.4c1.3-1.2,1-3.8-0.8-5.7 C398,268.5,395.4,267.9,394.1,269.1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentSearch01);
export default __webpack_public_path__ + "static/media/talent_search-01.deea2011f8e844b2159e3e8bedd08f01.svg";
export { ForwardRef as ReactComponent };